import React from 'react';
import { useParams } from 'react-router';

// Hooks
import { useToggle } from 'Shared/utils/hooks';

// Helpers
import * as ReviewFormTemplatesHelpers from 'Shared/model_helpers/ReviewFormTemplates.helper';

// Components
import { WpContainer, WpContainerBody, WpContainerFooter } from 'Wpds/components/container';
import { WpButton } from 'Wpds/components/button';
import { WpIcon } from 'Wpds/components/icon';
import ReviewForm from '../../ThreeSixtyReviewPartials/ReviewForm/ReviewForm';
import IndividualResposnesAlert from '../_partials/IndividualResposnesAlert';

// Styles
import './ReviewStep.scss';

type Props = {
  review?;
  peerReviewForm;
  answers;
  formData;
  handleBackClick: () => void;
  handleSubmitReview: () => void;
  isAlreadySubmitted: boolean;
  isPreview?: boolean;
  isSelfPeerReview?: boolean;
};

const ReviewStep = ({
  review,
  peerReviewForm,
  answers,
  formData,
  handleBackClick,
  handleSubmitReview,
  isAlreadySubmitted,
  isPreview,
  isSelfPeerReview,
}: Props) => {
  const { formSlug } = useParams();
  const [isSubmitting, toggleIsSubmitting] = useToggle(false);

  const questions = ReviewFormTemplatesHelpers.getQuestions(peerReviewForm);

  const handleSubmitClick = () => {
    if (isPreview) return null;
    toggleIsSubmitting();
    handleSubmitReview();
  };

  const baseClassName = 'ReviewStep';
  return (
    <div className={baseClassName}>
      <h5>Review & Submit</h5>
      {!isPreview && <IndividualResposnesAlert review={review} isSelfPeerReview={isSelfPeerReview} />}
      <WpContainer className={`${baseClassName}__review`}>
        <WpContainerBody>
          <ReviewForm formSlug={formSlug} questions={questions} answers={answers} formData={formData} />
        </WpContainerBody>
        {!isAlreadySubmitted && (
          <WpContainerFooter justifyContent="spaceBetween">
            <WpButton variant="tertiary" onClick={handleBackClick}>
              <WpIcon name="arrow-left" />
              Back
            </WpButton>
            <WpButton onClick={handleSubmitClick} loading={isSubmitting} disabled={isPreview}>
              Submit
            </WpButton>
          </WpContainerFooter>
        )}
      </WpContainer>
    </div>
  );
};

export default ReviewStep;
